import { useEffect } from 'react';
import { INACTIVITY_STORAGE_KEY } from './useInactivityTimeout';

export const useCrossTabSignOut = (onSignOut: () => void) => {
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === INACTIVITY_STORAGE_KEY && e.newValue === null) {
        onSignOut();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [onSignOut]);
};
